import '../style/skeleton-BRhCeFDi.css'
import { defineComponent as y, computed as f, ref as _, renderSlot as d, openBlock as o, createElementBlock as p, mergeProps as m, createBlock as h, unref as C, normalizeProps as W, createCommentVNode as A, createVNode as D, guardReactiveProps as T, Fragment as k, renderList as g, normalizeStyle as w, useCssVars as O, normalizeClass as L, resolveDynamicComponent as N, withCtx as V } from "vue";
import { pxlize as j } from "x-utils";
import z from "./icon.js";
import { getSpacingVariableByValue as M } from "./utils/style.js";
const S = /* @__PURE__ */ y({
  name: "e-skeleton",
  inheritAttrs: !1,
  __name: "skeleton",
  props: {
    shape: { default: "rect" },
    width: {},
    height: {},
    round: { type: Boolean },
    borderRadius: {},
    loading: { type: [Boolean, Object] },
    name: {},
    icon: {},
    justifySelf: {}
  },
  setup(a) {
    const e = a, l = f(() => ["e-skeleton", `e-skeleton--${e.shape}`, { "e-skeleton--round": e.round }]), n = _(null), r = f(() => {
      const t = {}, { width: u, height: i, borderRadius: s } = e;
      if (u) {
        const c = j(u);
        t.width = c, ["circle", "square"].includes(e.shape) && (t.height = c);
      }
      return i && (t.height = j(i)), s && (t.borderRadius = s), t;
    });
    return (t, u) => t.$slots.default && !t.loading ? d(t.$slots, "default", { key: 0 }) : t.$slots?.name && !t.loading ? d(t.$slots, "default", { key: 1 }) : (o(), p("div", m({
      key: 2,
      ref_key: "skeleton",
      ref: n,
      class: l.value,
      style: r.value
    }, t.$attrs), [
      t.icon ? (o(), h(C(z), W(m({ key: 0 }, t.icon)), null, 16)) : A("", !0)
    ], 16));
  }
}), H = /* @__PURE__ */ y({
  name: "e-skeleton-wrapper",
  inheritAttrs: !1,
  __name: "skeleton-wrapper",
  props: {
    height: {},
    skeleton: {},
    loading: { type: [Boolean, Object] }
  },
  setup(a) {
    return (e, l) => e.$slots.default && !e.loading ? d(e.$slots, "default", { key: 0 }) : e.$slots?.name && !e.loading ? d(e.$slots, "default", { key: 1 }) : (o(), p("div", m({
      key: 2,
      class: "e-skeleton-wrapper"
    }, e.$attrs), [
      D(S, W(T(e.skeleton)), null, 16)
    ], 16));
  }
}), b = { min: 10, max: 100, unit: "%" }, F = 14;
function B(a) {
  const e = /^(\d+)(px|em|rem|vw|%)$/, l = a.toString(), n = l.match(e);
  return {
    value: Number(l.replace(e, "$1")),
    unit: n?.[2] || "px"
  };
}
function G(a, e) {
  if (a && e) {
    const { unit: l, value: n } = B(a), { unit: r, value: t } = B(e);
    return typeof a !== typeof e ? (console.error("[e-skeleton-lines] minWidth and maxWidth must be the same type"), b) : n > t ? (console.error("[e-skeleton-lines] minWidth should less than the maxWidth"), b) : l !== r ? (console.error("[e-skeleton-lines] minWidth and maxWidth must be the same unit"), b) : {
      min: n,
      max: t,
      unit: l
    };
  }
  if (a) {
    const { unit: l, value: n } = B(a);
    let r = 0;
    switch (l) {
      case "px":
        r = window.innerWidth;
        break;
      case "em":
      case "rem":
        r = Math.round(window.innerWidth / F);
        break;
      case "%":
      case "vw":
        r = 100;
        break;
    }
    return {
      min: n,
      max: r,
      unit: l
    };
  }
  if (e) {
    const { unit: l, value: n } = B(e);
    return {
      min: 0,
      max: n,
      unit: l
    };
  }
  return b;
}
const K = /* @__PURE__ */ y({
  name: "e-skeleton-lines",
  inheritAttrs: !1,
  __name: "skeleton-lines",
  props: {
    gap: { default: 8 },
    numberOfLines: { default: 1 },
    lines: { default: () => [] },
    random: { type: Boolean },
    minWidth: {},
    maxWidth: {},
    height: {},
    loading: { type: [Boolean, Object] },
    name: {}
  },
  setup(a) {
    const e = a, l = f(() => e.lines.length ? e.lines.map((n) => ({ height: e.height, ...n })) : e.random && !e.minWidth && !e.maxWidth ? (console.error("[e-skeleton-lines] minWidth or maxWidth are required when random is true"), []) : Array.from({ length: e.numberOfLines }, () => {
      let n = "100%";
      if (e.random) {
        const { min: r, max: t, unit: u } = G(e.minWidth, e.maxWidth);
        n = `${Math.floor(Math.random() * (t - r + 1)) + r}${u}`;
      }
      return {
        width: n,
        height: e.height
      };
    }));
    return (n, r) => n.$slots.default && !n.loading ? d(n.$slots, "default", { key: 0 }) : n.$slots?.name && !n.loading ? d(n.$slots, "default", { key: 1 }) : (o(), p("div", m({
      key: 2,
      class: "e-skeleton-lines"
    }, n.$attrs, {
      class: `gap-${n.gap}`
    }), [
      (o(!0), p(k, null, g(l.value, (t, u) => (o(), h(S, m({ ref_for: !0 }, t, { key: u }), null, 16))), 128))
    ], 16));
  }
}), U = /* @__PURE__ */ y({
  name: "e-skeleton-grid",
  __name: "skeleton-grid",
  props: {
    items: { default: () => [] },
    gridStyle: {},
    loading: { type: [Boolean, Object] },
    name: {}
  },
  setup(a) {
    return (e, l) => (o(), p("div", {
      class: "e-skeleton-grid",
      style: w(e.gridStyle)
    }, [
      e.$slots.default && !e.loading ? d(e.$slots, "default", { key: 0 }) : e.$slots?.name && !e.loading ? d(e.$slots, "default", { key: 1 }) : (o(!0), p(k, { key: 2 }, g(e.items, (n, r) => (o(), h(S, m({ ref_for: !0 }, n, {
        key: r,
        style: { gridArea: n.name, justifySelf: n.justifySelf }
      }), null, 16, ["style"]))), 128))
    ], 4));
  }
}), Y = /* @__PURE__ */ y({
  name: "e-skeleton-flex",
  __name: "skeleton-flex",
  props: {
    items: { default: () => [] },
    space: { default: 8 },
    flexDirection: { default: "row" },
    loading: { type: [Boolean, Object] },
    name: {}
  },
  setup(a) {
    O((t) => ({
      "3ac26096": C(r)
    }));
    const e = a, l = f(() => [
      "e-skeleton-flex",
      `flex-${e.flexDirection}`
    ]), n = f(() => {
      const t = {};
      return e.flexDirection && (t.flexDirection = e.flexDirection), t;
    }), r = M(e.space);
    return (t, u) => (o(), p("div", {
      class: L(["e-skeleton-flex", l.value]),
      style: w(n.value)
    }, [
      t.$slots.default && !t.loading ? d(t.$slots, "default", { key: 0 }) : t.$slots?.name && !t.loading ? d(t.$slots, "default", { key: 1 }) : (o(!0), p(k, { key: 2 }, g(t.items, (i, s) => (o(), h(S, m({ ref_for: !0 }, i, {
        key: s,
        style: { flex: i.flex }
      }), null, 16, ["style"]))), 128))
    ], 6));
  }
}), Z = /* @__PURE__ */ y({
  name: "e-skeleton-rows",
  inheritAttrs: !1,
  __name: "skeleton-rows",
  props: {
    gap: {},
    gridTemplateColumns: {},
    numberOfRows: { default: 1 },
    columns: { default: () => [] },
    rowStyle: {},
    rowHeight: {},
    skeletonStyle: {},
    loading: { type: [Boolean, Object] },
    name: {}
  },
  setup(a) {
    O((s) => ({
      "56046c92": l.value
    }));
    const e = a, l = f(() => e.gap ? e.gap.split(" ")[0] : "8px");
    function n(s) {
      return s ? s.trim().replace(/repeat\((\d+),[\w\s(),]+\)/g, "$1x").replace(/\w+\(\w+,[\w\s]+\)/, "1x").split(" ").reduce(($, v) => ($ += /^\d+x$/.test(v) ? parseInt(v) : 1, $), 0) : 0;
    }
    const r = f(() => {
      const s = {};
      return e.gridTemplateColumns && (s.gridTemplateColumns = e.gridTemplateColumns), e.gap && (s.gap = e.gap), s;
    }), t = f(() => {
      const s = { ...e.rowStyle, ...r.value };
      return e.gap && (s.gap = e.gap), s;
    }), u = f(() => e.columns.length || n(e.gridTemplateColumns)), i = f(() => new Array(u.value).fill({}).map((s, c) => e.columns[c] || {}));
    return (s, c) => s.$slots.default && !s.loading ? d(s.$slots, "default", { key: 0 }) : s.name && s.$slots[s.name] && !s.loading ? d(s.$slots, "default", { key: 1 }) : u.value ? (o(), p("div", m({
      key: 2,
      class: "e-skeleton-rows"
    }, s.$attrs), [
      d(s.$slots, "header", {
        style: w(t.value),
        className: "e-skeleton-header"
      }),
      (o(!0), p(k, null, g(s.numberOfRows, ($) => (o(), p("div", {
        key: $,
        class: "e-skeleton-row",
        style: w(t.value)
      }, [
        (o(!0), p(k, null, g(i.value, (v, R) => (o(), h(S, m({ ref_for: !0 }, v, {
          key: `${$}-${R}`,
          style: { ...s.skeletonStyle, justifySelf: v.justifySelf }
        }), null, 16, ["style"]))), 128))
      ], 4))), 128))
    ], 16)) : A("", !0);
  }
}), J = /* @__PURE__ */ y({
  name: "e-skeleton-group",
  __name: "skeleton-groups",
  props: {
    space: { default: 8 },
    groups: { default: () => [] }
  },
  setup(a) {
    O((u) => ({
      "6ff1ed7a": C(t)
    }));
    const e = a, l = f(() => ["e-skeleton-group"]), n = f(() => ({})), r = f(() => e.groups.map((i) => ({
      name: i.name,
      componentType: i.type ? `e-skeleton-${i.type}` : "e-skeleton",
      props: i.props
    }))), t = M(e.space);
    return (u, i) => (o(), p("div", {
      class: L(["e-skeleton-group", l.value]),
      style: w(n.value)
    }, [
      (o(!0), p(k, null, g(r.value, (s, c) => (o(), h(N(s.componentType), m({ ref_for: !0 }, s.props, { key: c }), {
        default: V(() => [
          d(u.$slots, s.name, {
            props: s.props
          })
        ]),
        _: 2
      }, 1040))), 128))
    ], 6));
  }
});
export {
  Y as SkeletonFlex,
  U as SkeletonGrid,
  J as SkeletonGroups,
  K as SkeletonLines,
  Z as SkeletonRows,
  H as SkeletonWrapper,
  S as default
};
//# sourceMappingURL=skeleton.js.map
